import React, { useMemo } from 'react'
import styled from 'styled-components'
import { ConstelaConfiguration } from '../../../types/ConstelaConfiguration'
import ModuleData from '../../../types/ModuleData'
import { useSelector } from '../../store/hooks'
import PreviewModule from './PreviewModule'
import { SingularModuleWrap } from './PreviewSingularModule'
import { getPreviewData } from './previewUtils'

export type PreviewLuminaryProps = {
  configuration: ConstelaConfiguration
  scale: number
  availableModules: ModuleData[]
}

const SteleWrap = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  position: relative;
`

const PreviewLuminary: React.FC<PreviewLuminaryProps> = ({ configuration, scale, availableModules }) => {
  const { lightingHead, supportingColumn, singularModules, variableModules } = useMemo(
    () =>
      getPreviewData(
        configuration,
        availableModules,
        false /* Skip enumeration because we don't show the labels anyways */
      ),
    [availableModules, configuration]
  )
  const widthmm = useSelector((state) => state.data.system.width)

  return (
    <SteleWrap width={widthmm * scale}>
      <PreviewModule module={lightingHead?.data} scale={scale} />
      {variableModules.map(({ data, index }) => (
        <PreviewModule key={'variable-module-' + index} module={data} scale={scale} />
      ))}
      {singularModules.map(({ data, index }) => (
        <SingularModuleWrap key={'singular-module-' + index} module={data} scale={scale}>
          <PreviewModule module={data} scale={scale} />
        </SingularModuleWrap>
      ))}
      <PreviewModule module={supportingColumn?.data} scale={scale} />
    </SteleWrap>
  )
}

export default PreviewLuminary
